import Settings from './Settings';

export default function AuthService($http, localStorageService) {
  this.vslLogin = function() {
    console.log('AuthService.vslLogin');

    var config = {
      headers: {
        'X-AUTH-TOKEN': 'anonymous',
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'application/json'
      }
    };

    return $http.post(Settings.vslAuthUrl, '', config).then(function(response) {
      console.log('AuthService.vslLogin response: ', response);
      var accessToken = response.data.access_token;

      localStorageService.set('vslAuthToken', accessToken);

      return accessToken;
    });
  };

  this.vslLogout = function() {
    localStorageService.remove('vslAuthToken');
  };
}

export function AuthServiceStub($httpBackend) {
  $httpBackend
    .whenPOST('/vsl/jwt/token')
    .respond(function(method, url, data) {
      return [200, {access_token: 'TOKEN'}, {/* response header */}];
    });
}




/** WEBPACK FOOTER **
 ** ./src/olr-common/AuthService.js
 **/